import { Sparkles, Check } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { useCheckout } from "@/hooks/useMimis";
import { PlanButton } from "@/components/site/PriceCard";

const PERKS = ["Starter 9€: 10 video al mese", "Pro 19€: video illimitati", "Pro: il nome della tua attività nel finale"];

export const PaywallDialog = ({ open, onOpenChange, limit = false }) => {
  const { start, busy } = useCheckout();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-md overflow-hidden rounded-[1.75rem] border-0 p-0" data-testid="paywall-dialog" data-lenis-prevent>
        <div className="bg-[#111111] px-7 pb-7 pt-8 text-white">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-[#0066FF] px-3 py-1.5 text-xs font-semibold"><Sparkles className="h-3.5 w-3.5" /> MIMIS Video Italia</span>
          <DialogTitle className="font-display mt-5 text-2xl font-bold leading-tight sm:text-3xl" data-testid="paywall-title">
            {limit ? "Passa a Pro" : "Ti è piaciuto?"}
          </DialogTitle>
          <DialogDescription className="mt-2 text-base text-zinc-300" data-testid="paywall-text">
            {limit ? "Video illimitati e il nome della tua attività nel finale dei video." : "Scegli il piano giusto per te. Disdici quando vuoi."}
          </DialogDescription>
        </div>
        <div className="px-7 pb-7 pt-6">
          <ul className="space-y-2.5">
            {PERKS.map((p) => (
              <li key={p} className="flex items-center gap-2.5 text-[0.95rem]"><Check className="h-4 w-4 shrink-0 text-[#0066FF]" /> {p}</li>
            ))}
          </ul>
          {!limit && <PlanButton plan="starter" onClick={start} busy={busy} />}
          <PlanButton plan="pro" onClick={start} busy={busy} dark />
          <button onClick={() => onOpenChange(false)} className="mt-3 w-full text-sm font-medium text-[#52525b] hover:text-[#111111]" data-testid="paywall-close">Più tardi</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
